import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchFolderList } from "../store/ReportDataSlice";
import FolderDataTable from "./FolderDataTable";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";


const FolderList = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.reportData || {});

  useEffect(() => {
    dispatch(fetchFolderList());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Folder List"
            title="Dashboard"
            subtitle="Folder List"
            name="Add Payroll"
            // onAddClick={() => dispatch(openModal())} 
          />
          <FolderDataTable data={data} loading={loading} />

        </div>
      </div>
    </div>
  );
};

export default FolderList;
